import { store } from "quasar/wrappers";
import { Cookies, LocalStorage } from "quasar";

import { pinia } from "src/boot/pinia-store";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { oidc } from "src/boot/oidc";

import { axiosInstance } from "src/boot/axios";
import { API_ENDPOINTS } from "src/constants/api-endpoints";

//import stores which you want to reset on logout
import { useCommonStore } from "./common-store";
import { useDashboardStore } from "./dashboard-store";
import { useDialogStore } from "./dialog-store";
import { useFriendStore } from "./friend-store";
import { usePersistedStore } from "./persisted-store";
import { useUserInfo } from "./user-store";
import { useDealDetails } from "./mydeals-store";
import { useSwagshopStore } from "./swagshop-store";
import { useMoreStore } from "./more-store";
import CookieStorage from "src/utils/CookieStorage";
import { useGiftStore } from "./gift-store";
import { useLottery } from "./useLottery";
import { useSignUp } from "./signUp-store";
import { useShowCaseStore } from "./showcase-store";
import { useshippingAddress } from "./shippingAddress-store";
import { useReceipts } from "./receipts-store";
import { useAltriaStore } from "./altria-store";
import { useCompleteDeals } from "./completeDeals-store";
import { useVersionUpdateStore } from "./versionupdate-store";
import { useleadrBoardDetails } from "./leaderboard-store";
import { useMessages } from "./message-store";
import { useMfg } from "./mfg-store";
import { useStoreDetails } from "./mystores-store";
import { useNotificationDetails } from "./notification-store";
import { resetAllowedCoordinates } from "src/utils/geolocation";

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store(({ ssrContext }) => {
  const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies,
    options = { path: "/", expires: 1 };

  // const pinia = createPinia();

  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)
  pinia.use(() => ({
    $request: axiosInstance,
    apiEndpoints: API_ENDPOINTS,
    $oidc: oidc,
  }));
  // pinia.use(createPersistedState({
  //   storage: Cookies,
  // }));
  // pinia.use(piniaPluginPersistedstate);
  pinia.use(
    createPersistedState({
      storage:
        process.env.MODE == "ssr" ? new CookieStorage(Cookies) : LocalStorage,
      beforeRestore: () => {},
      afterRestore: () => {},
      serializer: {
        serialize: JSON.stringify,
        deserialize: JSON.parse,
      },
    })
  );
  return pinia;
});

export const resetAllStores = () => {
  const storesList = [
    useCommonStore(),
    useDashboardStore(),
    useDialogStore(),
    useFriendStore(),
    usePersistedStore(),
    useUserInfo(),
    useDealDetails(),
    useSwagshopStore(),
    useMoreStore(),
    useAltriaStore(),
    useCompleteDeals(),
    useVersionUpdateStore(),
    useleadrBoardDetails(),
    useMessages(),
    useMfg(),
    useStoreDetails(),
    useNotificationDetails(),
    useGiftStore(),
    useLottery(),
    useSignUp(),
    useShowCaseStore(),
    useshippingAddress(),
    useReceipts(),
  ];
  storesList.forEach((store) => {
    store.$reset();
  });
  // the cached location fix is module state, so $reset() does not clear it
  resetAllowedCoordinates();
};
